import { z } from "zod";

export const string = z.string().trim();
export const cuid = z.cuid2();

export const userName = string.min(3).max(50);

export const email = z.email().toLowerCase();

export const dateTime = z.coerce.date();

export const userRole = z.enum(["admin", "user"]);
export type UserRole = z.infer<typeof userRole>;
